import { render, staticRenderFns } from "./CaseCommentAttachmentComposer.vue?vue&type=template&id=4eee0482&scoped=true&"
import script from "./CaseCommentAttachmentComposer.vue?vue&type=script&lang=js&"
export * from "./CaseCommentAttachmentComposer.vue?vue&type=script&lang=js&"
import style0 from "./CaseCommentAttachmentComposer.vue?vue&type=style&index=0&id=4eee0482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eee0482",
  null
  
)

export default component.exports